<template>
	<div>
		<el-row type="flex" class="row">
			<el-col>
				<span class="bold">工作单位：</span>{{entity.workProvince}}
			</el-col>
			<el-col>
				<span class="bold">工作城市：</span>{{entity.workCity}}
			</el-col>
			<el-col>
				<span class="bold">工作区/县：</span>{{entity.workDistrict}}
			</el-col>
		</el-row>
		
		<el-row type="flex" class="row">
			<el-col><span class="bold">个人简介：</span>{{entity.personIntro}}</el-col>
		</el-row>
		
		<el-row style="width: 100%;" class="row">
			<el-col style="width: 25%;" align="center">
				<el-image title="身份证" lazy class="pic" :preview-src-list="getPicPre(entity)"
					:initial-index="0" :src="config.RESOURCES+entity.idFrontPic" fit="contain" />
				<p>身份证</p>
			</el-col>
			<el-col style="width: 25%;" align="center">
				<el-image lazy class="pic" :src="config.RESOURCES+entity.idReversePic" fit="contain"
					:preview-src-list="getPicPre(entity)" :initial-index="1" />
				<p>身份证</p>
			</el-col>
			<el-col style="width: 25%;" align="center">
				<el-image lazy class="pic" :src="config.RESOURCES+entity.physicianLicence" fit="contain"
					:preview-src-list="getPicPre(entity)" :initial-index="2" />
				<p>医师资格证</p>
			</el-col>
			<el-col style="width: 25%;" align="center">
				<el-image lazy class="pic" :src="config.RESOURCES+entity.personalPic" fit="contain"
					:preview-src-list="getPicPre(entity)" :initial-index="3" />
				<p>个人照片</p>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		
		props: {
			entity: {
				type: Object,
			},
		},
		methods: {
			/**
			 * @param {Object} row
			 */
			getPicPre(entity) {
				return [
					this.config.RESOURCES + entity.idFrontPic,
					this.config.RESOURCES + entity.idReversePic,
					this.config.RESOURCES + entity.physicianLicence,
					this.config.RESOURCES + entity.personalPic,
				]
			},
		},
	}
</script>

<style>
</style>